import MenuItem from "@mui/material/MenuItem";
import { FormHelperText, Select, Checkbox, ListItemText } from "@mui/material";

const FilterMultiSelect = ({
  options = [],
  formData = {},
  onUpdate = () => {},
  name = "",
  labelKey = "",
  valueKey = "",
  errorText = "",
  defaultText = "Select Option",
  disabled = false,
}) => {
  const handleChange = (event) => {
    const { name: fieldName, value } = event.target;
    if (Array.isArray(value) && value.includes("")) {
      onUpdate(fieldName, []);
      return;
    }
    onUpdate(fieldName, value);
  };

  const rawValue = formData[name];
  const selectedValues = Array.isArray(rawValue)
    ? rawValue
    : rawValue !== undefined && rawValue !== null && rawValue !== ""
    ? [rawValue]
    : [];

  return (
    <>
      <Select
        sx={{ maxWidth: "100%" }}
        fullWidth
        name={name}
        value={selectedValues}
        onChange={handleChange}
        error={!!errorText}
        size="small"
        displayEmpty
        disabled={disabled}
        className="select"
        multiple
        renderValue={(selected) => {
          if (!selected || selected.length === 0) {
            return <em className="select">{defaultText}</em>;
          }
          return options
            .filter((option) => selected.includes(option[valueKey]))
            .map((option) => option[labelKey])
            .join(", ");
        }}
      >
        <MenuItem key="" value="">
          <em className="select">{defaultText}</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option[valueKey]} value={option[valueKey]}>
            <Checkbox
              size="small"
              checked={selectedValues.indexOf(option[valueKey]) > -1}
            />
            <ListItemText primary={option[labelKey]} />
          </MenuItem>
        ))}
      </Select>
      {errorText && <FormHelperText error>{errorText}</FormHelperText>}
    </>
  );
};

export default FilterMultiSelect;
